
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web_seminars/event/[id]",
      function () {
        return require("private-next-pages/web_seminars/event/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web_seminars/event/[id]"])
      });
    }
  